// Firebase configuration for v8
import firebase from 'firebase/app';
import 'firebase/messaging';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAxMSDiUrSV_KBgBzxMQhPgGNQipmOZ1pU",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "mettletech-pos.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "mettletech-pos",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "mettletech-pos.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "511594174590",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:511594174590:web:a111bc7d791a6a6ae6a02f",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-E6SQM1QSYS"
};

// Initialize Firebase with compat API
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
// Initialize messaging with service worker registration
let messaging;
try {
  // Register service worker with explicit scope
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then(registration => {
        console.log('Service worker registered with scope:', registration.scope);
        // Initialize Firebase messaging with the service worker registration
        try {
          messaging = firebase.messaging();
          messaging.useServiceWorker(registration);
        } catch (err) {
          console.warn('Failed to initialize Firebase messaging:', err.message);
          messaging = null;
        }
      })
      .catch(err => {
        console.error('Service worker registration failed:', err);
      });
  } else {
    try {
      messaging = firebase.messaging();
    } catch (err) {
      console.warn('Firebase messaging not supported:', err.message);
      messaging = null;
    }
  }
} catch (error) {
  console.error('Error setting up Firebase messaging:', error);
  // Don't try to initialize messaging - browser may not support it
  messaging = null;
}

// Ensure messaging is initialized
const ensureMessaging = () => {
  return new Promise((resolve) => {
    // Check if messaging is already initialized
    if (messaging) {
      resolve(messaging);
      return;
    }

    // If not initialized, wait for service worker registration
    const checkInterval = setInterval(() => {
      if (messaging) {
        clearInterval(checkInterval);
        resolve(messaging);
      }
    }, 100);

    // Timeout after 5 seconds
    setTimeout(() => {
      clearInterval(checkInterval);
      // If messaging is still not initialized, leave it as null
      if (!messaging) {
        console.warn('Firebase Messaging not available after 5 seconds');
        resolve(null);
      }
    }, 5000);
  });
};

// Request permission function
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      // Ensure messaging is initialized
      const messagingInstance = await ensureMessaging();
      
      // If messaging is not available, return null
      if (!messagingInstance) {
        console.warn('Firebase Messaging not available, cannot get FCM token');
        return null;
      }
      
      // Get FCM token
      return messagingInstance.getToken({
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
      }).then(currentToken => {
        if (currentToken) {
          console.log('FCM token acquired successfully');
          return currentToken;
        } else {
          console.log('No FCM token available');
          return null;
        }
      });
    } else {
      console.log('Notification permission denied');
      return null;
    }
  } catch (error) {
    console.error('Error getting notification permission:', error);
    return null;
  }
};

// Listen for messages function
export const onMessageListener = async () => {
  try {
    // Ensure messaging is initialized before setting up listener
    const messagingInstance = await ensureMessaging();
    
    // If messaging is not available, reject
    if (!messagingInstance) {
      console.warn('Firebase Messaging not available');
      return Promise.reject(new Error('Firebase Messaging not available'));
    }
    
    return new Promise((resolve) => {
      messagingInstance.onMessage((payload) => {
        resolve(payload);
      });
    });
  } catch (error) {
    console.error('Error setting up message listener:', error);
    return Promise.reject(error);
  }
};

export default firebase;
